<template>
  <div class="c-finish-view">
    <div class="c-view-container">
      <div>
        <h1 class="c-finish-view__heading">{{ Finished.FinishedViewTitle }}</h1>

        <div class="c-view-container__inner">
          <div class="c-finish-view-content-col c-view-content-col">
            <div
              class="c-finish-view-content-col__inner c-view-content-col__inner"
            >
              <div class="c-finish-view-tips">
                <h2 class="c-finish-view-tips__heading">
                  {{ Finished.FinishedViewTipTitle }}
                </h2>

                <div class="c-finish-view-tips__inner">
                  <div
                    class="c-finish-view-tip"
                    v-if="Finished.FinishedViewTipOne != ''"
                  >
                    <img
                      class="c-finish-view-tip__image"
                      src="_resources/app/client/assets/images/coin.svg"
                      alt="coin"
                    />

                    <div class="c-finish-view-tip__text">
                      <div v-html="Finished.FinishedViewTipOne"></div>
                    </div>
                  </div>

                  <div
                    class="c-finish-view-tip"
                    v-if="Finished.FinishedViewTipTwo != ''"
                  >
                    <img
                      class="c-finish-view-tip__image"
                      src="_resources/app/client/assets/images/coin.svg"
                      alt="coin"
                    />

                    <div class="c-finish-view-tip__text">
                      <div v-html="Finished.FinishedViewTipTwo"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="c-finish-view-content">
                <div
                  class="c-finish-view-content__text"
                  v-html="Finished.FinishedViewResourcesContent"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-view-controls__wrapper">
      <div class="c-view-controls">
        <div class="c-view-controls__inner c-view-controls__inner--end">
          <div class="c-view-finish__controls">
            <EmailYourSavingsButton />
            <button class="u-calc-button" @click="resetCalculator">
              <p>Back to the start</p>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import EmailYourSavingsButton from "../EmailYourSavingsButton.vue";

export default {
  created() {},
  components: {
    EmailYourSavingsButton,
  },
  mounted() {},
  methods: {
    resetCalculator() {
      this.$store.commit("resetCalculator");
    },
  },
  computed: {
    ...mapFields(["config.baseUrl", "viewContent.Finished"]),
    /**
     * Returns animation url
     *
     * @return string
     * **/
    animationsURL() {
      return this.baseUrl + "/app/animations/";
    },
  },
};
</script>
<style lang="scss">
.c-finish-view {
  padding-top: 80px;

  @media (max-width: 755px) {
    padding-top: 40px;
  }

  .c-view-container__inner {
    @media (max-width: 755px) {
      flex-direction: column-reverse;
    }
  }

  .c-view-controls__wrapper {
    position: relative;
  }
}

.c-finish-view__heading {
  font-family: "Nunito" !important;
  font-weight: 800 !important;
  font-size: 48px !important;
  line-height: 54px !important;
  margin: 0 !important;
  color: #ffffff;

  @media (max-width: 755px) {
    font-size: 32px !important;
    line-height: 36px !important;
    margin-bottom: 12px;
  }
}
.c-finish-view-tips__heading {
  font-family: "Nunito" !important;
  font-weight: 800 !important;
  font-size: 32px !important;
  line-height: 43px !important;
  margin: 0 !important;

  @media (max-width: 755px) {
    font-size: 18px !important;
    line-height: 22px !important;
  }
}

.c-finish-view-content-col {
  // width: 70% !important;

  // @media (max-width: 755px) {
  //   width: 100% !important;
  // }
  width: 100% !important;
}

.c-finish-view-content-col__inner {
  max-width: none !important;
}

.c-finish-view_right-col {
  width: 30%;
}

.c-finish-view_right-col__calculator {
  width: 100%;
  height: auto;
}

.c-finish-view-tips {
  padding-right: 20px;

  @media (max-width: 755px) {
    padding-right: 0;
  }
}

.c-finish-view-tips__inner {
  margin-top: 34px;
}
.c-finish-view-tip {
  display: flex;
  align-items: flex-start;
  padding-bottom: 15px;
}

.c-finish-view-tip__text {
  margin-left: 12px;

  p {
    font-weight: 300 !important;
  }
}

.c-finish-view-content {
  background-color: #ffffff;
  border-radius: 26px;
  padding: 17px 29px;
  margin-top: 34px;

  a {
    color: #72d6b2 !important;
  }
}

.c-view-finish__controls {
  display: flex;
  flex-direction: column;

  .u-calc-button {
    margin-top: 5px;
  }
}
</style>
